import { AsyncPipe, CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, inject, input } from '@angular/core';

import { defaultIfEmpty, filter, switchMap } from 'rxjs';

import { CamTenantService } from '@camelot/server';
import { EmptyComponent, ErrorComponent, LoaderComponent, TitleComponent } from '@camelot/ui';
import { CamBaseComponent, isNonNullable } from '@camelot/utils';

import { CamCmsService } from '../../services/cms.service';
import { CamTranslationStrapi } from '../../translation.service';
import { RichTextComponent } from '../types/rich-text/rich-text.component';

@Component({
  selector: 'cam-cms',
  templateUrl: './cms.component.html',
  styleUrls: ['./cms.component.scss'],
  imports: [
    CommonModule,
    TitleComponent,
    RichTextComponent,
    AsyncPipe,
    LoaderComponent,
    ErrorComponent,
    EmptyComponent,
  ],
})
export class CmsComponent extends CamBaseComponent implements OnInit {
  contentType = input.required<string>();

  public cmsService = inject(CamCmsService);
  private _tenantService = inject(CamTenantService);

  constructor() {
    super();
    CamTranslationStrapi.getInstance();
  }

  get content$() {
    return this.cmsService.cmsContents.get$(this.contentType());
  }

  ngOnInit() {
    this.requestState.asked();

    this._registerSubscription(
      this._tenantService.currentTenantId$
        .pipe(
          filter(isNonNullable),
          // A content type with nothing published completes without emitting, which would leave the
          // loader spinning forever — `defaultIfEmpty` lets the empty state be shown instead.
          switchMap(tenantId =>
            this.cmsService.fetchCmsContents$(this.contentType(), tenantId.toString()).pipe(defaultIfEmpty(null))
          )
        )
        .subscribe({
          error: (error: HttpErrorResponse) => this.requestState.onError(error.status, error.statusText),
          next: () => this.requestState.completed(),
        })
    );
  }
}
